import { Box } from '@mui/system';
import Navbar from '../../components/navbar/navbar';
import { useAuthContext } from '../../../contexts/authContext';
import { ModulesSideBar } from '../../components/navbar/components';
import { ILayout } from '../../../shared/types/latyout';

export function LayoutDefault({ children }: ILayout) {
    const { tokenAuth } = useAuthContext();
    return (
        <Box sx={{ flexGrow: 1, ml: tokenAuth && 9.5, minWidth: 400 }}>
            {tokenAuth && <Navbar modules={ModulesSideBar} />}

            <Box
                component="main"
                sx={{ flexGrow: 1, p: 3, mt: tokenAuth ? 6.5 : 2 }}
            >
                {children}
            </Box>
        </Box>
    );
}
